import Input, { InputProps } from 'Components/Input/Input';
import { FormikValues, useFormikContext } from 'formik';
import React, { useCallback } from 'react';

const FormInput: React.FC<InputProps> = ({ id, disabled, type, ...rest }) => {
  const { setFieldValue, getFieldMeta } = useFormikContext<FormikValues>();

  const isError = !!getFieldMeta(id).value && getFieldMeta(id).touched && !disabled;

  const handleChangeEvent = useCallback(
    (val: any) => {
      if (
        type === 'number' &&
        typeof val === 'string' &&
        val !== '' &&
        val !== null &&
        !Number.isNaN(+val)
      ) {
        setFieldValue(id, +val);
        return;
      }
      setFieldValue(id, val);
    },
    [id, type, setFieldValue]
  );

  return (
    <Input
      id={id}
      value={getFieldMeta(id).value}
      errorMessage={isError ? getFieldMeta(id).error : ''}
      disabled={disabled}
      onChange={handleChangeEvent}
      {...rest}
    />
  );
};

export default FormInput;
